angular.module('gym.calendar').factory('EventMessageService', ["bulkMessageService", function(bulkMessageService) {
  return {
    messageAttendees: function(bookings) {
      var recipients;
      recipients = bookings.map(function(booking) {
        var ref;
        if ((ref = booking.attributes) != null ? ref.student : void 0) {
          return booking.attributes.student;
        } else {
          return booking.student;
        }
      });
      return bulkMessageService.setRecipients(recipients);
    }
  };
}]);
